var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67.3298C52.0015 67.3298 67 52.3314 67 33.8298C67 15.3283 52.0015 0.329834 33.5 0.329834C14.9985 0.329834 0 15.3283 0 33.8298C0 52.3314 14.9985 67.3298 33.5 67.3298Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 24.6752V43.6449C16.75 44.6769 17.5054 45.5133 18.546 45.5133H48.1514C49.191 45.5133 49.9474 44.6672 49.9474 43.6449V24.6752C49.9474 23.5427 49.2709 22.6631 48.1514 22.6631H18.546C17.3833 22.6631 16.75 23.5643 16.75 24.6752ZM19.4797 26.3276C19.4797 25.8704 19.7564 25.6089 20.1983 25.6089C20.4717 25.6089 31.2296 32.4256 31.8812 32.8255L33.5648 33.8726C34.0987 33.5149 34.6347 33.2091 35.188 32.8384C36.3172 32.1166 46.3651 25.6089 46.6417 25.6089C47.0848 25.6089 47.3604 25.8704 47.3604 26.3276C47.3604 26.8117 46.4278 27.2926 45.8204 27.6632C42.0047 29.9888 38.19 32.524 34.4121 34.936C34.1916 35.0851 33.7648 35.4039 33.4449 35.3553C33.0883 35.3001 22.1413 28.2673 20.1497 27.0959C19.8504 26.9197 19.4797 26.7587 19.4797 26.3276Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.7a7d99af90e218c0d43a2c9e27e9a8d2.svg";
export { ForwardRef as ReactComponent };